import React from 'react';
import styled from 'styled-components';
import Button from '../Button';

import './ServiceLoginIntro.scss';

const Footer = styled.div`
  position: absolute;
  bottom: 20px;
  text-align: center;

  @media (max-width: 767px), (max-height: 610px) {
    position: static;
    margin-top: 10px;
  }
`;

const renderStatement = (statement) => (statement ? <div className="statement">{statement}</div> : null);

const renderFooter = (footer) => (footer ? <Footer data-test="service-intro-footer">{footer}</Footer> : null);

const ServiceLoginIntro = (props) => {
  return (
    <div data-test="service-login-intro" className="box login-intro relative">
      <h2 className="title bg-source-bg-c">{props.title}</h2>
      <Button
        dataTest={props.dataTest}
        text={props.actionTitle}
        icon={props.btnIcon}
        colorName="link"
        className={`login ${props.btnClass}`}
        onClick={props.actionHandler}
      />
      {renderStatement(props.statement)}
      {renderFooter(props.footer)}
    </div>
  );
};

export default ServiceLoginIntro;
